import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { OrderHeader } from '@usf/ngrx-order';
import { ORDER_EXCEPTIONS_TRACING_ACTIONS } from './order-exceptions-tracing.actions';
import { OrderExceptionsTracingMessages } from './order-exceptions-tracing.constants';

@Injectable({
  providedIn: 'root',
})
export class OrderExceptionsTracingService {
  dispatchRouteAction(tracking: Tracking, routeString: string) {
    switch (this.parseUrl(routeString)) {
      case 'order-confirmation':
        this.store.dispatch(
          ORDER_EXCEPTIONS_TRACING_ACTIONS.traceViewExceptionsLinkClickedFromOrderConf(
            { tracking },
          ),
        );
        break;

      case 'submitted-order':
        this.store.dispatch(
          ORDER_EXCEPTIONS_TRACING_ACTIONS.traceViewExceptionsLinkClickedFromSubmittedOrder(
            { tracking },
          ),
        );
        break;

      default:
    }
  }

  parseUrl(routeString: string): string {
    const splitUrl = routeString.split('/');
    return splitUrl.length >= 4 ? splitUrl[3] : '';
  }

  processViewExceptionsLinkClick(
    orderHeader: OrderHeader,
    routeString: string,
  ) {
    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: 'order',
          isEndOfTrace: false,
          isStartOfTrace: true,
          attributes: {
            event: OrderExceptionsTracingMessages.viewExceptions,
            order: {
              orderId: orderHeader.orderId,
              tandemOrderNumber: orderHeader.tandemOrderNumber,
              totalAmount: orderHeader.totalDollars,
              requestedDeliveryDate: orderHeader.requestedDeliveryDate,
              confirmedDeliveryDate: orderHeader.confirmedDeliveryDate,
            },
          },
        },
        transformFunc: genericTracingTransformer,
      },
    };

    this.dispatchRouteAction(tracking, routeString);
  }

  trackPageLoad(
    orderId: string,
    origOrderId: string,
    origSplitOrderId: string,
    orderTotal: number,
    tandemOrderNumber: Number,
    requestedDeliveryDate: string | Date,
    confirmedDeliveryDate: string | Date,
  ) {
    const tracking: Tracking = {
      tracing: {
        data: {
          traceContext: 'order',
          isEndOfTrace: true,
          isStartOfTrace: true,
          attributes: {
            order: {
              orderId: orderId,
              origOrderId: !!origOrderId ? origOrderId : '',
              origSplitOrderId: !!origSplitOrderId ? origSplitOrderId : '',
              totalAmount: orderTotal,
              tandemOrderNumber: tandemOrderNumber,
              requestedDeliveryDate: requestedDeliveryDate,
              confirmedDeliveryDate: confirmedDeliveryDate,
            },
            event: OrderExceptionsTracingMessages.pageLoad,
          },
        },
        transformFunc: genericTracingTransformer,
      },
    };

    this.store.dispatch(
      ORDER_EXCEPTIONS_TRACING_ACTIONS.tracePageLoad({ tracking }),
    );
  }

  constructor(private store: Store) {}
}
